import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { useCurrentUser } from '../../hooks/useCurrentUser'

/**
 * Legal policy links.
 *
 * Locale-aware external URLs — the same ones the footer links to
 * (src/components/footer.jsx). Note the Spanish privacy page really is
 * `acuerdo-de-la-plataforma`; `politica-de-privacidad` does not exist (404).
 */
const LEGAL_LINKS = [
  {
    id: 'terms',
    en: 'https://civicrush.com/terms-of-service/',
    es: 'https://civicrush.com/terminos-de-servicio/',
    fallbackLabel: 'Terms of Service',
  },
  {
    id: 'privacy',
    en: 'https://civicrush.com/privacy-policy/',
    es: 'https://civicrush.com/acuerdo-de-la-plataforma/',
    fallbackLabel: 'Privacy Policy',
  },
]

export default function LegalModal({ show, onHide }) {
  const { t } = useTranslation()
  const { locale } = useCurrentUser()
  const isEs = locale === 'es'

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('settings.nav.legal', 'Legal')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-3 py-4">
        {LEGAL_LINKS.map(link => (
          <a
            key={link.id}
            href={(isEs && link.es) || link.en}
            target="_blank"
            rel="noreferrer"
            className="fw-bold text-decoration-none"
          >
            {t(`settings.legal.${link.id}`, link.fallbackLabel)}
          </a>
        ))}
      </Modal.Body>
    </Modal>
  )
}

LegalModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
}
